// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsHeader-cls1___4e20df3cbd89bb6f0ad{/*!*/}.NewsHeader-cls2__e2e6b84175681f34506a{width:24px;height:24px;border-radius:50%;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsHeader-cls1___4e20df3cbd89bb6f0ad",
	"cls2": "NewsHeader-cls2__e2e6b84175681f34506a NewsHeader-cls1___4e20df3cbd89bb6f0ad"
};
export default ___CSS_LOADER_EXPORT___;
